module.exports = __webpack_public_path__ + "img/aadhaar_bridge.079c90fd.png";